'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var xEngine = require('@financial-times/x-engine');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var xEngine__default = /*#__PURE__*/_interopDefaultLegacy(xEngine);

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var styles$4 = {"cta-container":"Footer_cta-container__C5LkX","btn-block":"Footer_btn-block__3cuse","btn":"Footer_btn__3DpWY","o-typography--loading-sans":"Footer_o-typography--loading-sans__1L8h1","btn--dark":"Footer_btn--dark__1Nv4A"};

var Footer = function Footer(_ref) {
  var link = _ref.link,
      ctaText = _ref.ctaText,
      BrandLogo = _ref.BrandLogo,
      defaultCtaText = _ref.defaultCtaText,
      darkButton = _ref.darkButton;
  return xEngine__default["default"].h("div", {
    className: styles$4['cta-container']
  }, xEngine__default["default"].h("div", {
    className: styles$4['btn-block']
  }, xEngine__default["default"].h("a", {
    href: link,
    className: "".concat(styles$4['btn'], " ").concat(darkButton ? styles$4['btn--dark'] : '').trim(),
    "data-trackable": "event-promo"
  }, ctaText || defaultCtaText)), xEngine__default["default"].h(BrandLogo, null));
};

var styles$3 = {"meta":"Meta_meta__3-7m8","o-typography--loading-sans":"Meta_o-typography--loading-sans__1iWp9"};

var Meta = function Meta(_ref) {
  var location = _ref.location,
      dates = _ref.dates;
  return xEngine__default["default"].h("div", {
    className: styles$3.meta
  }, !!location && xEngine__default["default"].h("p", null, location), !!dates && xEngine__default["default"].h("p", null, dates));
};

var detailStyles = {"block":"Details_block__14eq5","details":"Details_details__1C_NT","details--ft-board-director-programme-workshop":"Details_details--ft-board-director-programme-workshop__Go8D7","details--ft-forums":"Details_details--ft-forums__3OQku","details--ft-board-director-programme-diploma":"Details_details--ft-board-director-programme-diploma__5pC_w","details--ft-board-director-programme-masterclass":"Details_details--ft-board-director-programme-masterclass__1Gpqg","details--ft-board-director-programme-online-course":"Details_details--ft-board-director-programme-online-course__1uZgz","strapline":"Details_strapline__1w2yH","o-typography--loading-sans":"Details_o-typography--loading-sans__3B421","strapline--forum-promo":"Details_strapline--forum-promo__3FF2u","title":"Details_title__3bl5n","o-typography--loading-display-bold":"Details_o-typography--loading-display-bold__1KPsB","o-typography--loading-display":"Details_o-typography--loading-display__3q9D3"};

var commonStyles = {"visually-hidden":"common_visually-hidden__1ApdT"};

var EventDetails = function EventDetails(props) {
  return xEngine__default["default"].h("div", {
    className: detailStyles.block
  }, xEngine__default["default"].h("h2", {
    className: commonStyles['visually-hidden']
  }, "Event details and information"), xEngine__default["default"].h("div", {
    className: "".concat(detailStyles.details, " ").concat(props.detailsModifierClassname || '')
  }, xEngine__default["default"].h("a", {
    href: props.link,
    className: detailStyles.title,
    "data-trackable": "event-promo"
  }, props.title), xEngine__default["default"].h(Meta, props), xEngine__default["default"].h("div", {
    className: detailStyles.strapline
  }, xEngine__default["default"].h("p", null, props.strapline)), xEngine__default["default"].h(Footer, props)));
};

var ForumDetails = function ForumDetails(props) {
  return xEngine__default["default"].h("div", {
    className: detailStyles.block
  }, xEngine__default["default"].h("h2", {
    className: commonStyles['visually-hidden']
  }, "Forum details and information"), xEngine__default["default"].h("div", {
    className: "".concat(detailStyles.details, " ").concat(detailStyles['details--ft-forums'])
  }, xEngine__default["default"].h("a", {
    href: props.link,
    className: detailStyles.title,
    "data-trackable": "event-promo"
  }, props.title), xEngine__default["default"].h("div", {
    className: "".concat(detailStyles.strapline, " ").concat(detailStyles['strapline--forum-promo'])
  }, xEngine__default["default"].h("p", null, props.strapline)), xEngine__default["default"].h(Footer, props)));
};

var styles$2 = {"eventpromo":"Eventpromo_eventpromo__2UtVQ"};

var styles$1 = {"img-block":"Image_img-block__2NlGh","img":"Image_img__1fhJX"};

var Image = function Image(_ref) {
  var imageUrl = _ref.imageUrl,
      defaultImageUrl = _ref.defaultImageUrl,
      link = _ref.link;
  var baseSrc = "https://www.ft.com/__origami/service/image/v2/images/raw/".concat(imageUrl || defaultImageUrl, "?source=next&amp;fit=cover&amp;compression=best&amp;");
  var imgSrc = "".concat(baseSrc, "width=340 340w,").concat(baseSrc, "width=400 740w");
  return xEngine__default["default"].h("a", {
    className: styles$1['img-block'],
    href: link,
    "data-trackable": "event-promo",
    "aria-hidden": "true",
    tabIndex: "-1"
  }, xEngine__default["default"].h("img", {
    className: styles$1['img'],
    srcSet: imgSrc,
    alt: "",
    sizes: "(max-width: 46.24em) 100vw, 45vw"
  }));
};

var styles = {"brand":"BrandLogos_brand__1lzRM","o-typography--loading-sans":"BrandLogos_o-typography--loading-sans__QeUES","brand__logo-alt-text":"BrandLogos_brand__logo-alt-text__4ZwJv","brand--ft-live":"BrandLogos_brand--ft-live__1IDiv","brand--ft-forums":"BrandLogos_brand--ft-forums__1XgMu","brand--ft-board-director-programme":"BrandLogos_brand--ft-board-director-programme__2Bt3Z","brand--ft-board-director-programme-dark":"BrandLogos_brand--ft-board-director-programme-dark__sAB3c","visually-hidden":"BrandLogos_visually-hidden__3IOS_"};

var FTLiveLogo = function FTLiveLogo() {
  return xEngine__default["default"].h("div", {
    className: "".concat(styles['brand'], " ").concat(styles['brand--ft-live'])
  }, "Presented by", xEngine__default["default"].h("span", {
    className: "".concat(styles['brand__logo-alt-text'], " ").concat(commonStyles['visually-hidden'])
  }, "FT Live"));
};
var BDPLogo = function BDPLogo() {
  return xEngine__default["default"].h("div", {
    className: "".concat(styles['brand'], " ").concat(styles['brand--ft-board-director-programme'])
  }, "Presented by", xEngine__default["default"].h("span", {
    className: "".concat(styles['brand__logo-alt-text'], " ").concat(commonStyles['visually-hidden'])
  }, "FT Board Director Programme"));
};
var BDPLogoDark = function BDPLogoDark() {
  return xEngine__default["default"].h("div", {
    className: "".concat(styles['brand'], " ").concat(styles['brand--ft-board-director-programme-dark'])
  }, "Presented by", xEngine__default["default"].h("span", {
    className: "".concat(styles['brand__logo-alt-text'], " ").concat(commonStyles['visually-hidden'])
  }, "FT Board Director Programme"));
};
var ForumsLogo = function ForumsLogo() {
  return xEngine__default["default"].h("div", {
    className: "".concat(styles['brand'], " ").concat(styles['brand--ft-forums'])
  }, "Presented by", xEngine__default["default"].h("span", {
    className: "".concat(styles['brand__logo-alt-text'], " ").concat(commonStyles['visually-hidden'])
  }, "FT Forums"));
};

var audienceClapping = 'https://www.ft.com/__assets/creatives/better-promo/audiance_clapping.jpg';
var handShake = 'https://www.ft.com/__assets/creatives/better-promo/hand_shake.jpg';
var calculator = 'https://www.ft.com/__assets/creatives/better-promo/calculator.jpg';
var BRANDS = {
  'ft-live': {
    BrandLogo: FTLiveLogo,
    defaultCtaText: 'Register now',
    defaultImageUrl: audienceClapping
  },
  'ft-bdp:masterclass': {
    BrandLogo: BDPLogo,
    defaultCtaText: 'Apply now',
    defaultImageUrl: audienceClapping,
    detailsModifierClassname: detailStyles['details--ft-board-director-programme-masterclass']
  },
  'ft-bdp:workshop': {
    BrandLogo: BDPLogo,
    defaultCtaText: 'Book your place',
    defaultImageUrl: audienceClapping,
    detailsModifierClassname: detailStyles['details--ft-board-director-programme-workshop']
  },
  'ft-bdp:diploma': {
    BrandLogo: BDPLogo,
    defaultCtaText: 'Apply now',
    defaultImageUrl: audienceClapping,
    detailsModifierClassname: detailStyles['details--ft-board-director-programme-diploma']
  },
  'ft-bdp:online-course': {
    BrandLogo: BDPLogoDark,
    defaultCtaText: 'Book now',
    defaultImageUrl: calculator,
    detailsModifierClassname: detailStyles['details--ft-board-director-programme-online-course'],
    darkButton: true
  },
  'ft-forums': {
    BrandLogo: ForumsLogo,
    defaultCtaText: 'Get involved',
    defaultImageUrl: handShake,
    detailsModifierClassname: detailStyles['details--ft-forums']
  }
};
var getBranding = function getBranding(brand) {
  return BRANDS[brand] || BRANDS['ft-live'];
};

var Eventpromo = function Eventpromo(_ref) {
  var props = _extends({}, _ref);

  var branding = getBranding(props.brand || 'ft-live');
  return xEngine__default["default"].h("div", {
    className: styles$2.eventpromo,
    "data-event-focus": "",
    "data-event-brand": props.brand,
    "data-focus-concept": props.id
  }, xEngine__default["default"].h(EventDetails, _extends({}, branding, props)), xEngine__default["default"].h(Image, _extends({}, branding, props)));
};

var Forumpromo = function Forumpromo(_ref2) {
  var props = _extends({}, _ref2);

  var branding = getBranding('ft-forums');
  return xEngine__default["default"].h("div", {
    className: styles$2.eventpromo,
    "data-forum-id": props.id
  }, xEngine__default["default"].h(ForumDetails, _extends({}, branding, props)), xEngine__default["default"].h(Image, _extends({}, branding, props)));
};

exports.Eventpromo = Eventpromo;
exports.Forumpromo = Forumpromo;
